export const ROUTE_NAMES = {
  keyCountryIndicator: {
    add: 'KeyCountryIndicatorAdd',
    edit: 'KeyCountryIndicatorEdit',
  },
};
